import React from "react";
import { PixCancellationTemplate } from "../../Templates/PixCancellationTemplate";

export const PixCancellation = () => {
  return <PixCancellationTemplate />;
};
